import {
  STATUSES,
  makePaginationState,
  concatUnique,
} from 'app/utils/redux';

import * as t from './types';

const initialState = {
  badges: makePaginationState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${t.FETCH_BADGES}_PENDING`:
      return {
        ...state,
        badges: {
          ...state.badges,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_BADGES}_SUCCESS`:
      return {
        ...state,
        badges: {
          ...state.badges,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: concatUnique(
              state.badges.pagination.items,
              action.payload.result.items,
            ),
          },
        },
      };
    case `${t.FETCH_BADGES}_ERROR`:
      return {
        ...state,
        badges: {
          ...state.badges,
          status: STATUSES.ERROR,
        },
      };

    case `${t.OBTAIN_BADGE}_SUCCESS`:
      return {
        ...state,
        badges: {
          ...state.badges,
          pagination: {
            ...state.badges.pagination,
            items: state.badges.pagination.items
              .map((item) => {
                if (item.id === action.meta.id) {
                  return {
                    ...item,
                    hasBadge: true,
                  };
                }

                return item;
              }),
          },
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/badgeList/reducer.js